var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.is_weight_show)?_c('span',{staticClass:"sort_number_list"},_vm._l((_vm.srot_list),function(item,index){return _c('i',{class:'sort_number_'+item.id,on:{"click":function($event){return _vm.getSort(item)}}})}),0):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }